import { createFileRoute } from "@tanstack/react-router"
import { BackofficeScheduledReportEditor } from "modules/backoffice/components/scheduledReports/BackofficeScheduledReportEditor"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/scheduledReports/$id")({
  component: RouteComponent,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.scheduledReports.edit.title"),
    })
  },
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <BackofficeScheduledReportEditor scheduledReportId={id} />
}
